import { BandIndexGridBand } from "@/components/BandIndexGridBand";
import { BandIndexTableBand } from "@/components/BandIndexTableBand";
import { Spinner } from "@/components/Spinner";
import { preferredViewModeState } from "@/context/states";
import { useBandIndex } from "@/lib/api";
import Grid from "@mui/material/Grid";
import { useRecoilState } from "recoil";

export default function BandIndexPage({ index, count = 24 }) {
  const { bands, isLoading, isValidating, isError } = useBandIndex(
    index * count,
    count,
  );

  const [preferredViewMode, setPreferredViewMode] = useRecoilState(
    preferredViewModeState,
  );

  if (isError) {
    return <div>failed to load</div>;
  }

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      {preferredViewMode === "list" && (
        <>
          {bands.map((band) => (
            <Grid item xs={12} md={6} key={band.id}>
              <BandIndexTableBand band={band} href={`/musik/${band.slug}`} />
            </Grid>
          ))}
        </>
      )}
      {preferredViewMode === "grid" && (
        <>
          {bands.map((band) => (
            <Grid item xs={12} sm={6} md={4} key={band.id}>
              <BandIndexGridBand band={band} href={`/musik/${band.slug}`} />
            </Grid>
          ))}
        </>
      )}
    </>
  );
}
